import React from "react";
import { useTranslation } from "react-i18next";
import FileImport from "components/import/FileImport";
import { CardImport } from "network/wineImport";

const CardImportPage = () => {
  const { t } = useTranslation("wine");
  return (
    <FileImport
      title={t("import.card.title")}
      intro={t("import.card.intro")}
      columnsHelp={t("import.card.columnsHelp")}
      api={CardImport}
      allowPdf
      templateName="modello_carta_vini.csv"
      statuses={{
        added: [t("import.card.statusAdded"), "success"],
        requested: [t("import.card.statusRequested"), "warning"],
        skipped: [t("import.card.statusSkipped"), "secondary"],
        error: [t("import.card.statusError"), "danger"],
      }}
      counters={[["added", t("import.card.counterAdded")], ["requested", t("import.card.counterRequested")], ["skipped", t("import.card.counterSkipped")], ["errors", t("import.card.counterErrors")]]}
      confirmLabel={t("import.card.confirm")}
      doneHint={t("import.card.doneHint")}
    />
  );
};

export default CardImportPage;
